(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('CadastroColheitaCtrl', CadastroColheitaCtrl);

  CadastroColheitaCtrl.$inject = [
    '$q',
    '$location',
    '$rootScope',
    '$routeParams',
    'LoadingService',
    'ColheitaService',
    'MessagesService',
    'ItensService',
    'Flash',
    'CommonHTTPService',
    'AplicacoesService',
    'AtividadesService'
  ];

  // eslint-disable-next-line max-lines-per-function, max-params
  function CadastroColheitaCtrl($q, $location, $rootScope, $routeParams, LoadingService, ColheitaService,
    MessagesService, ItensService, Flash, CommonHTTPService, AplicacoesService, AtividadesService) {
    const vm = this;
    let tempColheita = null;

    // Controller data
    vm.glebas = [];
    vm.colheitas = [];
    vm.safras = [];
    vm.colheita = {
      safra: null,
      gleba: null,
      atividade: null,
      insumo: null,
      data_inicio: null,
      data_termino: null,
      area_total_ha: null,
      total_colhido_kg: null,
      total_colhido_ton: null
    };
    vm.totalColhidoSc = null;

    // Bindable functions
    vm.goToIndex = goToIndex;
    vm.goToShow = goToShow;
    vm.edit = edit;
    vm.delete = deleteFn;
    vm.save = save;
    vm.glebaDisabled = glebaDisabled;
    vm.atividadeDisabled = atividadeDisabled;
    vm.insumoDisabled = insumoDisabled;
    vm.loadSeedings = loadSeedings;
    vm.reset = reset;
    vm.changeTotalColhido = changeTotalColhido;
    vm.isCana = isCana;

    // Function declarations
    function goToIndex() {
      $location.path('/colheitas');
    }

    function goToShow() {
      $location.path(`/colheitas/${ vm.colheita.id || ''}`);
    }

    function edit() {
      $location.path(`/colheitas/${ vm.colheita.id }/edit`);
    }

    function deleteFn() {
      MessagesService.confirm('Deseja excluir este registro de colheita?').then(() => {
        LoadingService.showLoading();
        ColheitaService.delete(vm.colheita.id).then(() => {
          vm.goToIndex();
          Flash.create(REGISTRO_EXCLUIDO_COM_SUCESSO.type, REGISTRO_EXCLUIDO_COM_SUCESSO.msg);
        })
          .catch((err) => {
            console.error('Falha ao excluir o registro', err);
            Flash.create(FALHA_AO_EXCLUIR_REGISTRO.type, FALHA_AO_EXCLUIR_REGISTRO.msg);
            vm.goToIndex();
          })
          .finally(LoadingService.hideLoading);
      });
    }

    function save(form) {
      if (form.$invalid) {
        return;
      }

      LoadingService.showLoading();
      ColheitaService.save(vm.colheita).then(function(result) {
        vm.colheita.id = result.data.id;
        vm.goToShow();
        Flash.create(REGISTRO_SALVO_COM_SUCESSO.type, REGISTRO_SALVO_COM_SUCESSO.msg);
      })
        .catch((exception) => {
          if (CommonHTTPService.isBadRequest(exception.status) && exception.data) {
            Flash.create(FALHA_AO_SALVAR_REGISTRO.type, exception.data);
          } else {
            Flash.create(FALHA_AO_SALVAR_REGISTRO.type, FALHA_AO_SALVAR_REGISTRO.msg);
          }
        })
        .finally(LoadingService.hideLoading);
    }

    function error() {
      Flash.create(FALHA_AO_CONSULTAR_REGISTRO.type, FALHA_AO_CONSULTAR_REGISTRO.msg);
      $location.path('/colheitas');
      console.error(error);
    }

    function glebaDisabled() {
      return !vm.colheita.safra;
    }

    function atividadeDisabled() {
      return !vm.colheita.gleba;
    }

    function insumoDisabled() {
      return !vm.colheita.atividade;
    }

    function loadSeedings() {
      vm.glebas = [];
      reset();
      if (vm.colheita.safra) {
        LoadingService.showLoading();
        return AplicacoesService.listSeedings({
          safra: vm.colheita.safra.id,
          ignore_open: true
        })
          .then(({ data }) => {
            vm.glebas = getGlebas(data).filter((gleba) => !!((gleba.gleba || {}).descricao));
            return getInsumos();
          })
          .catch(error)
          .finally(LoadingService.hideLoading);
      }
    }

    function getGlebas(data) {
      return _.uniqBy(data, 'cd_gleba').map((seedingData) => {
        const glebaData = _.filter(data, { cd_gleba: seedingData.cd_gleba });
        const glebaAtividades = _.uniqBy(glebaData, 'cd_atividade');
        return {
          seedingData,
          gleba: _.find($rootScope.currentPropriedade.glebas, { id: seedingData.cd_gleba }),
          atividades: glebaAtividades.map((atividade) => ({
            id: atividade.cd_atividade,
            descricao: atividade.descricao_atividade,
            insumos: data
              .filter(
                (gleba) => gleba.cd_gleba === seedingData.cd_gleba &&
                gleba.cd_atividade === atividade.cd_atividade &&
                !!gleba.cd_item_estoque
              )
              .map((insumo) => _.pick(insumo, ['cd_item_estoque', 'tipo_item_estoque']))
          }))
        };
      });
    }

    function getInsumos() {
      const insumos = _.chain(vm.glebas)
        .flatMap('atividades')
        .flatMap('insumos')
        .uniqBy('cd_item_estoque')
        .value();
      if (insumos.length) {
        return ItensService.listCultivares({
          tipo_item: _.find(insumos, 'tipo_item_estoque').tipo_item_estoque,
          item: _.flatMap(insumos, 'cd_item_estoque').join()
        }).then(({ data }) => {
          // cria um hashmap com todos os insumos recebidos
          // pra evitar múltiplas iterações sobre alguns dos arrays
          const insumosMap = _.keyBy(data, 'item_id');
          _.flatMap(vm.glebas, 'atividades').forEach((atividade) => {
            // pega o insumo a partir do hashmap criado acima
            atividade.insumos = atividade.insumos
              .map((insumo) => insumosMap[insumo.cd_item_estoque]);
          });
        });
      }
      return $q.resolve();
    }

    function reset(gleba = true) {
      if (gleba) {
        vm.colheita.gleba = null;
      }
      vm.colheita.atividade = null;
      vm.colheita.insumo = null;
    }

    function changeTotalColhido(type) {
      if (vm.colheita.area_total_ha) {
        if (type === 'kg' && vm.colheita.total_colhido_kg) {
          vm.totalColhidoSc = vm.colheita.total_colhido_kg / vm.colheita.area_total_ha / 60;
        } else if (type === 'sc' && vm.totalColhidoSc) {
          vm.colheita.total_colhido_kg = vm.totalColhidoSc * 60 * vm.colheita.area_total_ha;
        } else if (type === 'ton') {
          vm.colheita.total_colhido_kg = vm.colheita.total_colhido_ton * 1000;
        }
      }
    }

    function isCana() {
      return AtividadesService.isCana(_.get(vm, 'colheita.atividade.descricao'));
    }

    // Controller logic

    LoadingService.showLoading();
    $rootScope.initialize.then(() => {
      if (!$rootScope.permissions.colheitas.canManage) {
        $location.path('/');
        Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
        return;
      }

      vm.safras = $rootScope.safras;

      if ($routeParams.id) {
        return ColheitaService.get($routeParams.id);
      }
    })
      .then((response) => {
        if (response) {
          tempColheita = response.data;
          vm.colheita.id = tempColheita.id;
          vm.colheita.safra = _.find(vm.safras, { id: tempColheita.safra.id });
          return loadSeedings();
        }
      })
      .then(() => {
        if ($routeParams.id) {
          vm.colheita.gleba = _.find(vm.glebas, { gleba: { id: tempColheita.gleba.id } });
          vm.colheita.atividade = _.find(vm.colheita.gleba.atividades, {
            id: tempColheita.atividade.id
          });
          vm.colheita.insumo = _.find(vm.colheita.atividade.insumos, {
            item_id: tempColheita.insumo.item_id
          });
          vm.colheita.data_inicio = new Date(tempColheita.data_inicio);
          vm.colheita.data_termino = new Date(tempColheita.data_termino);
          vm.colheita.area_total_ha = +tempColheita.area_total_ha;
          vm.colheita.total_colhido_kg = +tempColheita.total_colhido_kg;
          vm.colheita.total_colhido_ton = +tempColheita.total_colhido_kg / 1000;
          vm.colheita.atr_medio = +tempColheita.atr_medio;
          changeTotalColhido('kg');
          tempColheita = null;
        }
      })
      .catch(error)
      .finally(LoadingService.hideLoading);
  }
}());
